import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createPaymentAccountSignal, Icon } from '@millionshow/client-libs';
import { SettingService } from '@millionshow/api-client';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-guide-plan',
  standalone: true,
  imports: [CommonModule, Icon],
  templateUrl: './guide-plan.component.html',
})
export class GuidePlanComponent {
  private readonly settingService = inject(SettingService);

  email = toSignal(
    this.settingService.settingControllerFindByKey({ key: 'agritex_email' })
  );

  paymentAccount = createPaymentAccountSignal('agritex');
}
